import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Defect, DefectPrimaryKeyId, GuidId } from '../models';
import { ApiService } from './api/index';

/** Defect management service */
@Injectable({
  providedIn: 'root',
})
export class DefectService {
  constructor(private api: ApiService) {}

  /**
   *
   * @param projectGuid
   * @param defectId
   * @returns
   */
  getDefect(
    projectGuid: GuidId,
    defectId: DefectPrimaryKeyId
  ): Observable<{
    defect: Defect.Defect;
    photos: Defect.Photo[];
  }> {
    if (!environment.production) {
      console.log('getDefect()');
    }

    return this.api.client.getDefect(defectId, projectGuid).pipe(
      map((result) => {
        if (result.success) {
          const defect: Defect.Defect = {
            ...result.data,
            cloudId: result.data.id,
            created:
              result.data.createDate !== ''
                ? new Date(result.data.createDate)
                : new Date(),
            completed:
              result.data.completed !== ''
                ? new Date(result.data.completed)
                : undefined,
            dueDate:
              result.data.dueDate !== ''
                ? new Date(result.data.dueDate)
                : undefined,
          };

          const photos: Defect.Photo[] = [
            ...result.data.photo.map<Defect.Photo>((o) => {
              return {
                cloudId: o.cloudId,
                defectId: o.defectId,
                filename: o.filename,
                fullPath: o.fullPath,
                thumbnail: o.thumbnail,
                createdBy: o.createdBy,
                created: o.createDate ? new Date(o.createDate) : new Date(),
              };
            }),
          ];

          return { defect, photos };
        } else {
          throw new Error(result.message);
        }
      })
    );
  }
}
